import Vue from 'vue';
import ApiService from "@/common/api.service";
import {
  MONITOR_GET_TAGS,
  MONITOR_GET_CONSUMER_INSIGHTS,
  MONITOR_GET_CONSUMER_GENERATIONS,
  MONITOR_GET_MARKET_INSIGHTS,
  MONITOR_GET_MARKET_SECTORS,
  MONITOR_GET_GEOLOCALIZATION,
  MONITOR_GET_GENDER,
  MONITOR_GET_CUSTOMERS,
  MONITOR_GET_MARKETS,
  MONITOR_GET_LIST_CONSUMER,
  MONITOR_GET_LIST_MARKET,
  MONITOR_GET,
  MONITOR_CREATE,
  MONITOR_EDIT,
  MONITOR_DELETE,
  MONITOR_DUPLICATE,
  MONITOR_CHAPTER_GET_ALL,
  MONITOR_CHAPTER_CREATE,
  MONITOR_CHAPTER_EDIT,
  MONITOR_CHAPTER_DELETE,
  MONITOR_CHAPTER_PUBLISH,
  MONITOR_CHAPTER_DUPLICATE,
  MONITOR_PARAGRAPH_GET_ALL,
  MONITOR_PARAGRAPH_CREATE,
  MONITOR_PARAGRAPH_EDIT,
  MONITOR_PARAGRAPH_DELETE,
  MONITOR_PARAGRAPH_DUPLICATE,
  MONITOR_PARAGRAPH_OBJECT_GET_ALL,
  MONITOR_PARAGRAPH_OBJECT_CREATE,
  MONITOR_PARAGRAPH_OBJECT_EDIT,
  MONITOR_PARAGRAPH_OBJECT_DELETE,
  MONITOR_PARAGRAPH_OBJECT_ARCHIVE,
  MONITOR_PARAGRAPH_OBJECT_CONTENT_GET,
  MONITOR_PARAGRAPH_OBJECT_CONTENT_CREATE,
  MONITOR_PARAGRAPH_OBJECT_CONTENT_EDIT,
  MONITOR_TRASH_GET,
  MONITOR_TRASH_RESTORE,
  MONITOR_TRASH_DELETE,
  // MONITOR_TRASH_CHAPTER_PARAGRAPH_GET,
  // MONITOR_TRASH_CHAPTER_RESTORE,
  // MONITOR_TRASH_CHAPTER_DELETE,
  // MONITOR_TRASH_PARAGRAPH_RESTORE,
  // MONITOR_TRASH_PARAGRAPH_DELETE,
  // MONITOR_TRASH_PARAGRAPH_OBJECT_RESTORE,
  // MONITOR_TRASH_PARAGRAPH_OBJECT_DELETE,
  MONITOR_HISTORY_GET
} from "./actions.type";
import {
  STATE_MONITORS_TAGS_SET,
  STATE_MONITORS_CONSUMER_INSIGHTS_SET,
  STATE_MONITORS_CONSUMER_GENERATIONS_SET,
  STATE_MONITORS_MARKET_INSIGHTS_SET,
  STATE_MONITORS_MARKET_SECTORS_SET,
  STATE_MONITORS_GEOLOCALIZATION_SET,
  STATE_MONITORS_GENDER_SET,
  STATE_MONITORS_CUSTOMERS_SET,
  STATE_MONITORS_MARKETS_SET,
  STATE_MONITORS_SET_LIST_CONSUMER,
  STATE_MONITORS_SET_LIST_MARKET,
  STATE_MONITORS_CURRENT_CATEGORY_SET,
  STATE_MONITORS_CURRENT_TAG_SET,
  STATE_MONITORS_CURRENT_SET,
  STATE_MONITORS_CURRENT_CHAPTERS_SET,
  STATE_MONITORS_CURRENT_CHAPTER_SET,
  STATE_MONITORS_CURRENT_PARAGRAPHS_SET,
  STATE_MONITORS_CURRENT_PARAGRAPH_SET,
  STATE_MONITORS_STRUCTURE_CHAPTERS_SET,
  STATE_MONITORS_STRUCTURE_CHAPTERS_ORDER_SET,
  STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET,
  STATE_MONITORS_RECENT_TARGETS_SET,
  STATE_MONITORS_RECENT_TAXONOMIES_SET
} from "./mutations.type";

const state = {
  monitorTags: [],
  monitorConsumerInsights: [],
  monitorConsumerGenerations: [],
  monitorMarketInsights: [],
  monitorMarketSectors: [],
  monitorGeolocalization: [],
  monitorGender: [],
  monitorCustomers: [],
  monitorMarkets: [],
  monitorListConsumer: [],
  monitorListMarket: [],
  monitorCategory: '',
  monitorCurrent: {
    monitor: {},
    chapters: {},
    chapter: {},
    paragraphs: {},
    tag: null
  },
  monitorStructure: {},
  monitorRecentTargets: [],
  monitorRecentTaxonomies: []
};

const getters = {
  monitorTags(state) {
    return state.monitorTags;
  },
  monitorConsumerInsights(state) {
    return state.monitorConsumerInsights;
  },
  monitorConsumerGenerations(state) {
    return state.monitorConsumerGenerations;
  },
  monitorMarketInsights(state) {
    return state.monitorMarketInsights;
  },
  monitorMarketSectors(state) {
    return state.monitorMarketSectors;
  },
  monitorGeolocalization(state) {
    return state.monitorGeolocalization;
  },
  monitorGender(state) {
    return state.monitorGender;
  },
  monitorCustomers(state) {
    return state.monitorCustomers;
  },
  monitorMarkets(state) {
    return state.monitorMarkets;
  },
  monitorListConsumer(state) {
    return state.monitorListConsumer;
  },
  monitorListMarket(state) {
    return state.monitorListMarket;
  },
  monitorCategory(state) {
    return state.monitorCategory;
  },
  monitorCurrent(state) {
    return state.monitorCurrent;
  },
  monitorStructure(state) {
    return state.monitorStructure;
  },
  monitorRecentTargets(state) {
    return state.monitorRecentTargets;
  },
  monitorRecentTaxonomies(state) {
    return state.monitorRecentTaxonomies;
  }
}

const actions = {
  [MONITOR_GET_TAGS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("opers_tag/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_TAGS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_CONSUMER_INSIGHTS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("opers_consumer_insights/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_CONSUMER_INSIGHTS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_CONSUMER_GENERATIONS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("opers_consumer_generations/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_CONSUMER_GENERATIONS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_MARKET_INSIGHTS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("opers_market_insights/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_MARKET_INSIGHTS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_MARKET_SECTORS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("opers_market_sectors/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_MARKET_SECTORS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_GEOLOCALIZATION](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("geolocalizations/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_GEOLOCALIZATION_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_GENDER](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("genders/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_GENDER_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_CUSTOMERS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("generations/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_CUSTOMERS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_MARKETS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("markets/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_MARKETS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_LIST_CONSUMER](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("consumermonitors_list/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_SET_LIST_CONSUMER, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET_LIST_MARKET](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("marketmonitors_list/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_SET_LIST_MARKET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_GET](context, monitorId) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'monitors_details/';
      ApiService.setHeader();
      ApiService.get(endpoint + monitorId + "/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_CURRENT_SET, data);
          resolve(data);
        })
    })
  },
  [MONITOR_CREATE](context, payload) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'monitors_list/';
      ApiService.setHeader();
      ApiService.post(endpoint, payload.monitor)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_EDIT](context, payload) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'monitors_details/';
      ApiService.setHeader();
      ApiService.patch(endpoint + payload.monitorId + "/", payload.monitor)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_DELETE](context, monitor) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'monitors_details/';
      ApiService.setHeader();
      ApiService.delete(endpoint + monitor.id + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_DUPLICATE](context, monitorId) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + '_duplicate_monitor/';
      ApiService.setHeader();
      ApiService.patch(endpoint + monitorId + "/")
        .then(({ data }) => {
          if(context.rootState.monitors.monitorCategory == 'consumer') {
            this.dispatch(MONITOR_GET_LIST_CONSUMER, null, { root: true });
          }
          if(context.rootState.monitors.monitorCategory == 'market') {
            this.dispatch(MONITOR_GET_LIST_MARKET, null, { root: true });
          }
          resolve(data);
        })
    });
  },
  [MONITOR_CHAPTER_GET_ALL](context, monitorId) {
    return new Promise(resolve => {
      let endpoint;
      if(context.rootState.monitors.monitorCategory == 'consumer') {
        endpoint = 'consumerchapters_list/';
      }
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpoint = 'marketchapters_list/';
      }
      ApiService.setHeader();
      ApiService.get(endpoint + monitorId + "/")
        .then(({ data }) => {
          context.commit(STATE_MONITORS_CURRENT_CHAPTERS_SET, data);
          context.commit(STATE_MONITORS_STRUCTURE_CHAPTERS_SET, data);
          resolve(data);
        })
    });
  },
  [MONITOR_CHAPTER_CREATE](context, chapter) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'chapters_list/';
      ApiService.setHeader();
      ApiService.post(endpoint + chapter.monitorId + "/", chapter.chapterData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_CHAPTER_EDIT](context, data) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'chapters_details/';
      ApiService.setHeader();
      ApiService.patch(endpoint + data.monitorId + "/chapter/" + data.chapterId + "/", data.chapterData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_CHAPTER_DELETE](context, data) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'chapters_details/';
      ApiService.setHeader();
      ApiService.delete(endpoint + data.monitorId + "/chapter/" + data.chapterId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_CHAPTER_PUBLISH](context, data) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + 'monitors_publish/';
      ApiService.setHeader();
      ApiService.patch(endpoint, data)
        .then(({ data }) => {
          resolve(data);
          console.log('publish done');
        })
    });
  },
  [MONITOR_CHAPTER_DUPLICATE](context, chapterId) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.patch(context.rootState.monitors.monitorCategory + "_duplicate_chapter/" + chapterId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_GET_ALL](context, chapterId) {
    return new Promise(resolve => {
      let structureParagraphs = {
        chapterId: chapterId
      }
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.get(endpointPrefix + "paragraphs_list/" + chapterId + "/")
        .then(({ data }) => {
          // context.commit(STATE_MONITORS_CURRENT_PARAGRAPHS_SET, data);
          structureParagraphs.paragraphs = data;
          context.commit(STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET, structureParagraphs);
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_CREATE](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.post(endpointPrefix + "paragraphs_list/" + data.chapterId + "/", data.paragraphData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_EDIT](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.patch(endpointPrefix + "paragraphs_list/" + data.chapterId + "/details/" + data.paragraphId + "/", data.paragraphData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_DELETE](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.delete(endpointPrefix + "paragraphs_list/" + data.chapterId + "/details/" + data.paragraphId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_DUPLICATE](context, paragraphId) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.patch(context.rootState.monitors.monitorCategory + "_duplicate_paragraph/" + paragraphId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_GET_ALL](context, paragraphId) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.get(endpointPrefix + "paragraphs_list_objects/" + paragraphId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_CREATE](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.post(endpointPrefix + "paragraphs_list_objects/" + data.paragraphId + "/", data.paragraphObjectData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_EDIT](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.patch(endpointPrefix + "paragraphs_list_objects/" + data.paragraphId + "/details/" + data.paragraphObjectId + "/", data.paragraphObjectData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_DELETE](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.setHeader();
      ApiService.delete(endpointPrefix + "paragraphs_list_objects/" + data.paragraphId + "/details/" + data.paragraphObjectId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_ARCHIVE](context, data) {
    return new Promise(resolve => {
      ApiService.setHeader();
      let endpointPrefix = 'operators_';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      ApiService.post(endpointPrefix + "archive/", data)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_CONTENT_GET](context, data) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("paragraphs_list_objects/" + data.paragraphId + "/details/" + data.paragraphObjectId + "/")
        .then(({ data }) => {
          console.log('data', data);
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_CONTENT_CREATE](context, data) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.post("paragraphs_list_objects/" + data.paragraphId + "/details/" + data.paragraphObjectId + "/", data.paragraphObjectData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_PARAGRAPH_OBJECT_CONTENT_EDIT](context, data) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.patch("paragraphs_list_objects/" + data.paragraphId + "/details/" + data.paragraphObjectId + "/", data.paragraphObjectData)
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_TRASH_GET](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      let endpoint = endpointPrefix + data.type + "_garbage/for_tag/";
      ApiService.setHeader();
      ApiService.get(endpoint + data.tagId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_TRASH_RESTORE](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      let endpoint = endpointPrefix + data.type + "_garbage/";
      ApiService.setHeader();
      ApiService.patch(endpoint + data.objectId + "/garbage/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  [MONITOR_TRASH_DELETE](context, data) {
    return new Promise(resolve => {
      let endpointPrefix = '';
      if(context.rootState.monitors.monitorCategory == 'market') {
        endpointPrefix = 'market_';
      }
      let endpoint = endpointPrefix + data.type + "_garbage/";
      ApiService.setHeader();
      ApiService.delete(endpoint + data.objectId + "/garbage/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  },
  // [MONITOR_TRASH_CHAPTER_PARAGRAPH_GET](context, monitorId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.get("monitors_garbage/" + monitorId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  // [MONITOR_TRASH_CHAPTER_RESTORE](context, chapterId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.update("chapters/" + chapterId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  // [MONITOR_TRASH_CHAPTER_DELETE](context, chapterId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.delete("chapters/" + chapterId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  // [MONITOR_TRASH_PARAGRAPH_RESTORE](context, paragraphId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.update("paragraphs/" + paragraphId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  // [MONITOR_TRASH_PARAGRAPH_DELETE](context, paragraphId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.delete("paragraphs/" + paragraphId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  // [MONITOR_TRASH_PARAGRAPH_OBJECT_RESTORE](context, paragraphObjectId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.update("paragraph_objects/" + paragraphObjectId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  // [MONITOR_TRASH_PARAGRAPH_OBJECT_DELETE](context, paragraphObjectId) {
  //   return new Promise(resolve => {
  //     ApiService.setHeader();
  //     ApiService.delete("paragraph_objects/" + paragraphObjectId + "/garbage/")
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //   });
  // },
  [MONITOR_HISTORY_GET](context, tagId) {
    return new Promise(resolve => {
      let endpoint = context.rootState.monitors.monitorCategory + '_history/';
      ApiService.setHeader();
      ApiService.get(endpoint + tagId + "/")
        .then(({ data }) => {
          resolve(data);
        })
    });
  }
}

const mutations = {
  [STATE_MONITORS_TAGS_SET](state, tags) {
    state.monitorTags = tags;
  },
  [STATE_MONITORS_CONSUMER_INSIGHTS_SET](state, consumerInsights) {
    state.monitorConsumerInsights = consumerInsights;
  },
  [STATE_MONITORS_CONSUMER_GENERATIONS_SET](state, consumerGenerations) {
    state.monitorConsumerGenerations = consumerGenerations;
  },
  [STATE_MONITORS_MARKET_INSIGHTS_SET](state, marketInsights) {
    state.monitorMarketInsights = marketInsights;
  },
  [STATE_MONITORS_MARKET_SECTORS_SET](state, marketSectors) {
    state.monitorMarketSectors = marketSectors;
  },
  [STATE_MONITORS_GEOLOCALIZATION_SET](state, geolocalization) {
    state.monitorGeolocalization = geolocalization;
  },
  [STATE_MONITORS_GENDER_SET](state, gender) {
    state.monitorGender = gender;
  },
  [STATE_MONITORS_CUSTOMERS_SET](state, customers) {
    state.monitorCustomers = customers;
  },
  [STATE_MONITORS_MARKETS_SET](state, markets) {
    state.monitorMarkets = markets;
  },
  [STATE_MONITORS_SET_LIST_CONSUMER](state, monitors) {
    state.monitorListConsumer = monitors;
  },
  [STATE_MONITORS_SET_LIST_MARKET](state, monitors) {
    state.monitorListMarket = monitors;
  },
  [STATE_MONITORS_CURRENT_CATEGORY_SET](state, category) {
    state.monitorCategory = category;
  },
  [STATE_MONITORS_CURRENT_TAG_SET](state, tag) {
    state.monitorCurrent.tag = tag;
  },
  [STATE_MONITORS_CURRENT_SET](state, monitor) {
    state.monitorCurrent.monitor = monitor;
  },
  [STATE_MONITORS_CURRENT_CHAPTERS_SET](state, chapters) {
    state.monitorCurrent.chapters = chapters;
  },
  [STATE_MONITORS_CURRENT_CHAPTER_SET](state, chapter) {
    state.monitorCurrent.chapter = chapter;
  },
  [STATE_MONITORS_CURRENT_PARAGRAPHS_SET](state, paragraphs) {
    state.monitorCurrent.paragraphs = paragraphs;
  },
  [STATE_MONITORS_CURRENT_PARAGRAPH_SET](state, paragraph) {
    state.monitorCurrent.paragraph = paragraph;
  },
  [STATE_MONITORS_STRUCTURE_CHAPTERS_SET](state, chapters) {
    state.monitorStructure = chapters;
  },
  [STATE_MONITORS_STRUCTURE_CHAPTERS_ORDER_SET](state, chapters) {
    for (var i = 0; i < chapters.length; i++) {
      for (var j = 0; i < state.monitorStructure.length; i++) {
        if(chapters[i].chapter_id == state.monitorStructure[j].chapter_id) {
          if(!Object.prototype.hasOwnProperty.call(state.monitorStructure[j], "paragraphs")) {
            chapters[i].paragraphs = state.monitorStructure[j].paragraphs;
          }
        }
      }
      state.monitorStructure = chapters;
    }
  },
  [STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET](state, paragraphs) {
    for (var i = 0; i < state.monitorStructure.length; i++) {
      if(state.monitorStructure[i].chapter_id == paragraphs.chapterId) {
        if(!Object.prototype.hasOwnProperty.call(state.monitorStructure[i], "paragraphs")) {
          // Non esistendo la key paragraph, la impostiamo per rendere reattiva anche questa parte di monitorStructure   
          Vue.set(state.monitorStructure[i], 'paragraphs', []);
        }
        state.monitorStructure[i].paragraphs = paragraphs.paragraphs;
      }
    }
  },
  [STATE_MONITORS_RECENT_TARGETS_SET](state, target) {
    let found = false;
    if (state.monitorRecentTargets.filter(function(e) { return e.gandtarget_id === target.gandtarget_id; }).length > 0) {
      found = true;
    }
    if(!found) {
      state.monitorRecentTargets.unshift(target);
      state.monitorRecentTargets = state.monitorRecentTargets.slice(0, 5);
    }
  },
  [STATE_MONITORS_RECENT_TAXONOMIES_SET](state, taxonomy) {
    let found = false;
    if (state.monitorRecentTaxonomies.filter(function(e) { return e.tax_id === taxonomy.tax_id; }).length > 0) {
      found = true;
    }
    if(!found) {
      state.monitorRecentTaxonomies.unshift(taxonomy);
      state.monitorRecentTaxonomies = state.monitorRecentTaxonomies.slice(0, 5);
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
};